(function () {
  if (window.Shopify && window.Shopify.designMode) return;
  if (window.__easifyEarlyDefer) return;
  window.__easifyEarlyDefer = true;

  var path = window.location.pathname || '';
  var isEasifyPage =
    path.indexOf('/products/') === 0 || path === '/cart' || path.endsWith('/cart');
  var easifyUrl = /easify-product-options/i;

  function isEasifyAsset(url) {
    return !!url && easifyUrl.test(url);
  }

  function parkScript(node) {
    var src = node.getAttribute('src');
    if (!src || !isEasifyAsset(src)) return;
    if (node.getAttribute('type') === 'text/plain') return;
    if (node.getAttribute('data-easify-managed') === '1') return;

    var placeholder = document.createElement('script');
    placeholder.type = 'text/plain';
    placeholder.setAttribute('data-deferred-script', src);
    placeholder.setAttribute('data-easify-managed', '1');
    placeholder.setAttribute('data-easify-deferred', '1');

    if (node.type === 'module' || node.getAttribute('type') === 'module') {
      placeholder.setAttribute('data-deferred-module', 'true');
      if (node.crossOrigin === 'anonymous' || node.getAttribute('crossorigin') === 'anonymous') {
        placeholder.setAttribute('data-deferred-crossorigin', 'anonymous');
      }
    }
    if (node.async) placeholder.setAttribute('data-async', 'true');
    if (node.defer) placeholder.setAttribute('data-defer', 'true');

    try {
      node.type = 'text/plain';
      node.removeAttribute('src');
    } catch (e) {}

    if (node.parentNode) node.parentNode.replaceChild(placeholder, node);
  }

  function handleCss(link) {
    if (!link || link.getAttribute('data-easify-managed') === '1') return;
    var href = link.getAttribute('href') || link.getAttribute('data-easify-css-href') || '';
    if (!isEasifyAsset(href) && !(link.getAttribute('href') || '').match(easifyUrl)) return;
    href = link.getAttribute('href') || link.getAttribute('data-easify-css-href') || '';
    if (!isEasifyAsset(href)) return;
    link.setAttribute('data-easify-managed', '1');

    if (isEasifyPage) {
      link.setAttribute('data-softdelay', '1');
      link.media = 'print';
      link.onload = function () {
        this.media = 'all';
      };
      return;
    }

    link.setAttribute('data-easify-css-href', href);
    link.removeAttribute('href');
    link.media = 'print';
    try {
      link.disabled = true;
    } catch (e) {}
  }

  function handleNode(node) {
    if (!node || node.nodeType !== 1) return;

    if (node.matches) {
      if (node.matches('script[src]')) {
        var src = node.getAttribute('src') || '';
        if (isEasifyAsset(src) && !isEasifyPage) parkScript(node);
      }
      if (node.matches('link[rel="stylesheet"]')) handleCss(node);
    }

    if (node.querySelectorAll) {
      if (!isEasifyPage) {
        node.querySelectorAll('script[src]').forEach(function (s) {
          if (isEasifyAsset(s.getAttribute('src') || '')) parkScript(s);
        });
      }
      node.querySelectorAll('link[rel="stylesheet"]').forEach(handleCss);
    }
  }

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var nodes = mutations[i].addedNodes;
      for (var j = 0; j < nodes.length; j++) handleNode(nodes[j]);
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });

  function sweep() {
    document.querySelectorAll('script[src], link[rel="stylesheet"]').forEach(handleNode);
  }

  sweep();
  window.addEventListener('DOMContentLoaded', sweep);
  window.addEventListener('load', function () {
    sweep();
    setTimeout(function () {
      sweep();
      observer.disconnect();
    }, 4000);
  });
})();
